import { useState } from "react";
import { MapPin, User } from "react-feather";
import { validateRequestLocation } from "../../../validations/validateRequestCreation";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../../store/request-slice";
import QuickRequestLocation from "./QuickRequestLocation";
import QuickRequestConsignee from "./QuickRequestConsignee";
import { FORMS, MODULES } from "../../../../const";
import { validateQuickRequestLocation } from "../../../validations/ValidateQuickRequestCreation";

const QuickLocationConsigneeItem = ({
  dropdown,
  errors,
  editMode,
  onShowLocation,
  isLoading,
}) => {
  const [tab, setTab] = useState(1);
  const [swicthedToConsigee, setSwitchedToConsigee] = useState(false);
  const hasLocErrors = useSelector((state) => state.request.hasLocErrors);
  const hasConErrors = useSelector((state) => state.request.hasConErrors);
  const submitted = useSelector((state) => state.request.submitted);
  const dispatch = useDispatch();
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );

  const multiConsigneeType = useSelector(
    (state) => state.request.reqMultiConsignee
  );
  const requestLocationsRequests = useSelector(
    (state) => state.request.requestLocationsRequests
  );
  const requestLocationViewPermission =
    auth[FORMS.QUICK_REQUEST.LOCATION.form]?.FORM?.VIEW;
  const requestConsigneeViewPermission =
    auth[FORMS.QUICK_REQUEST.CONSIGNEE.form]?.FORM?.VIEW;

  const validateSetLocations = () => {
    const errors = [];
    const requestStartLocation = requestLocationsRequests.find(
      (location) => location.rlkLocationType === 1
    );
    const requestEndLocation = requestLocationsRequests.find(
      (location) => location.rlkLocationType === 2
    );
    const startLocationErrors = validateQuickRequestLocation(requestStartLocation);
    const endLocationErrors = validateQuickRequestLocation(requestEndLocation);

    const startLocationValidationFailed =
      Object.keys(startLocationErrors).length > 0;
    const endLocationValidationFailed =
      Object.keys(endLocationErrors).length > 0;
    if (startLocationValidationFailed) {
      dispatch(requestActions.setRequest({ startLocationErrors }));
    }
    if (endLocationValidationFailed) {
      dispatch(requestActions.setRequest({ endLocationErrors }));
    }

    if (startLocationValidationFailed || endLocationValidationFailed) {
      return false;
    }
    if (errors.length > 0) {
      dispatch(requestActions.setRequest({ validationErrors: errors }));
      return false;
    } else {
      return true;
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <div className="ui top attacehd tablular menu">
        <div
          className={`item ${tab === 1 ? "active" : ""}`}
          style={
            requestLocationViewPermission
              ? {
                  color:
                    (swicthedToConsigee || submitted) && hasLocErrors
                      ? "#e0b4b4"
                      : "",
                  borderColor:
                    (swicthedToConsigee || submitted) && hasLocErrors
                      ? "#e0b4b4"
                      : "",
                }
              : { display: "none" }
          }
          onClick={() => {
            setTab(1);
          }}
        >
          <span>
            <MapPin size={15} style={{ marginRight: "5px" }} />
          </span>
          Location
        </div>

        {multiConsigneeType === 1 && (
          <div
            className={`item ${tab === 2 ? "active" : ""}`}
            style={
              requestConsigneeViewPermission
                ? {
                    color: hasConErrors ? "#e0b4b4" : "",
                    borderColor: hasConErrors ? "#e0b4b4" : "",
                  }
                : { display: "none" }
            }
            onClick={() => {
              dispatch(requestActions.setRequest({ startLocationErrors: {} }));
              dispatch(requestActions.setRequest({ endLocationErrors: {} }));
              if (validateSetLocations()) {
                dispatch(requestActions.setRequest({ hasLocErrors: false }));
              } else {
                dispatch(requestActions.setRequest({ hasLocErrors: true }));
              }
              setTab(2);
              setSwitchedToConsigee(true);
            }}
          >
            <span>
              <User size={15} style={{ marginRight: "5px" }} />
            </span>
            Consignees
          </div>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={
          requestLocationViewPermission
            ? { display: tab === 1 ? "block" : "none" }
            : { display: "none" }
        }
      >
        <QuickRequestLocation
          editMode={editMode}
          onShowLocation={onShowLocation}
          dropdown={{ locationFlagOptions: dropdown.locationFlagOptions }}
          errors={errors}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={
          requestConsigneeViewPermission
            ? { display: tab === 2 ? "block" : "none" }
            : { display: "none" }
        }
      >
        <QuickRequestConsignee
          editMode={editMode}
          dropdown={{
            consignmentTypeOptions: dropdown.consignmentTypeOptions,
          }}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default QuickLocationConsigneeItem;
